@file:OptIn(InternalResourceApi::class)

package crossly.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/crossly.shared.generated.resources/"

@delegate:ResourceContentHash(-2_143_370_678)
internal val Res.string.achievement_awesome: StringResource by lazy {
      StringResource("string:achievement_awesome", "achievement_awesome", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 39),
      ))
    }

@delegate:ResourceContentHash(-1_977_898_449)
internal val Res.string.achievement_share: StringResource by lazy {
      StringResource("string:achievement_share", "achievement_share", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50, 33),
      ))
    }

@delegate:ResourceContentHash(-1_947_549_976)
internal val Res.string.achievement_unlocked_kicker: StringResource by lazy {
      StringResource("string:achievement_unlocked_kicker", "achievement_unlocked_kicker", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84, 63),
      ))
    }

@delegate:ResourceContentHash(1_327_146_415)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148, 28),
      ))
    }

@delegate:ResourceContentHash(-830_569_191)
internal val Res.string.badge_brainstorm_25: StringResource by lazy {
      StringResource("string:badge_brainstorm_25", "badge_brainstorm_25", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246, 43),
      ))
    }

@delegate:ResourceContentHash(901_669_531)
internal val Res.string.badge_brainstorm_25_desc: StringResource by lazy {
      StringResource("string:badge_brainstorm_25_desc", "badge_brainstorm_25_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177, 68),
      ))
    }

@delegate:ResourceContentHash(-1_715_404_658)
internal val Res.string.badge_brainstorm_5: StringResource by lazy {
      StringResource("string:badge_brainstorm_5", "badge_brainstorm_5", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 358, 42),
      ))
    }

@delegate:ResourceContentHash(-1_764_937_064)
internal val Res.string.badge_brainstorm_5_desc: StringResource by lazy {
      StringResource("string:badge_brainstorm_5_desc", "badge_brainstorm_5_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 290, 67),
      ))
    }

@delegate:ResourceContentHash(-1_836_405_327)
internal val Res.string.badge_brainstormer: StringResource by lazy {
      StringResource("string:badge_brainstormer", "badge_brainstormer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 473, 42),
      ))
    }

@delegate:ResourceContentHash(-743_673_376)
internal val Res.string.badge_brainstormer_desc: StringResource by lazy {
      StringResource("string:badge_brainstormer_desc", "badge_brainstormer_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 401, 71),
      ))
    }

@delegate:ResourceContentHash(-1_677_477_379)
internal val Res.string.badge_first_daily: StringResource by lazy {
      StringResource("string:badge_first_daily", "badge_first_daily", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 575, 41),
      ))
    }

@delegate:ResourceContentHash(1_942_679_960)
internal val Res.string.badge_first_daily_desc: StringResource by lazy {
      StringResource("string:badge_first_daily_desc", "badge_first_daily_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 516, 58),
      ))
    }

@delegate:ResourceContentHash(92_915_335)
internal val Res.string.badge_first_numbers: StringResource by lazy {
      StringResource("string:badge_first_numbers", "badge_first_numbers", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 702, 47),
      ))
    }

@delegate:ResourceContentHash(959_149_265)
internal val Res.string.badge_first_numbers_desc: StringResource by lazy {
      StringResource("string:badge_first_numbers_desc", "badge_first_numbers_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 617, 84),
      ))
    }

@delegate:ResourceContentHash(-648_147_106)
internal val Res.string.badge_first_riddles: StringResource by lazy {
      StringResource("string:badge_first_riddles", "badge_first_riddles", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 827, 47),
      ))
    }

@delegate:ResourceContentHash(1_938_926_157)
internal val Res.string.badge_first_riddles_desc: StringResource by lazy {
      StringResource("string:badge_first_riddles_desc", "badge_first_riddles_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 750, 76),
      ))
    }

@delegate:ResourceContentHash(346_006_340)
internal val Res.string.badge_first_words: StringResource by lazy {
      StringResource("string:badge_first_words", "badge_first_words", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 954, 37),
      ))
    }

@delegate:ResourceContentHash(629_213_137)
internal val Res.string.badge_first_words_desc: StringResource by lazy {
      StringResource("string:badge_first_words_desc", "badge_first_words_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 875, 78),
      ))
    }

@delegate:ResourceContentHash(1_448_315_917)
internal val Res.string.badge_flawless: StringResource by lazy {
      StringResource("string:badge_flawless", "badge_flawless", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1056, 34),
      ))
    }

@delegate:ResourceContentHash(-1_877_426_087)
internal val Res.string.badge_flawless_desc: StringResource by lazy {
      StringResource("string:badge_flawless_desc", "badge_flawless_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 992, 63),
      ))
    }

@delegate:ResourceContentHash(-1_270_434_484)
internal val Res.string.badge_numbers_10: StringResource by lazy {
      StringResource("string:badge_numbers_10", "badge_numbers_10", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1165, 40),
      ))
    }

@delegate:ResourceContentHash(753_754_626)
internal val Res.string.badge_numbers_10_desc: StringResource by lazy {
      StringResource("string:badge_numbers_10_desc", "badge_numbers_10_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1091, 73),
      ))
    }

@delegate:ResourceContentHash(1_165_434_918)
internal val Res.string.badge_numbers_50: StringResource by lazy {
      StringResource("string:badge_numbers_50", "badge_numbers_50", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1280, 40),
      ))
    }

@delegate:ResourceContentHash(-1_590_912_415)
internal val Res.string.badge_numbers_50_desc: StringResource by lazy {
      StringResource("string:badge_numbers_50_desc", "badge_numbers_50_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1206, 73),
      ))
    }

@delegate:ResourceContentHash(-177_102_059)
internal val Res.string.badge_perfect_100: StringResource by lazy {
      StringResource("string:badge_perfect_100", "badge_perfect_100", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1388, 45),
      ))
    }

@delegate:ResourceContentHash(1_992_038_493)
internal val Res.string.badge_perfect_100_desc: StringResource by lazy {
      StringResource("string:badge_perfect_100_desc", "badge_perfect_100_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1321, 66),
      ))
    }

@delegate:ResourceContentHash(557_831_881)
internal val Res.string.badge_perfect_5: StringResource by lazy {
      StringResource("string:badge_perfect_5", "badge_perfect_5", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1499, 39),
      ))
    }

@delegate:ResourceContentHash(2_112_196_100)
internal val Res.string.badge_perfect_5_desc: StringResource by lazy {
      StringResource("string:badge_perfect_5_desc", "badge_perfect_5_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1434, 64),
      ))
    }

@delegate:ResourceContentHash(193_223_007)
internal val Res.string.badge_perfectionist: StringResource by lazy {
      StringResource("string:badge_perfectionist", "badge_perfectionist", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1608, 47),
      ))
    }

@delegate:ResourceContentHash(-61_046_963)
internal val Res.string.badge_perfectionist_desc: StringResource by lazy {
      StringResource("string:badge_perfectionist_desc", "badge_perfectionist_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1539, 68),
      ))
    }

@delegate:ResourceContentHash(1_325_173_524)
internal val Res.string.badge_phoenix: StringResource by lazy {
      StringResource("string:badge_phoenix", "badge_phoenix", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1840, 33),
      ))
    }

@delegate:ResourceContentHash(1_258_680_419)
internal val Res.string.badge_phoenix_3: StringResource by lazy {
      StringResource("string:badge_phoenix_3", "badge_phoenix_3", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1729, 39),
      ))
    }

@delegate:ResourceContentHash(-1_226_968_644)
internal val Res.string.badge_phoenix_3_desc: StringResource by lazy {
      StringResource("string:badge_phoenix_3_desc", "badge_phoenix_3_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1656, 72),
      ))
    }

@delegate:ResourceContentHash(-1_620_782_814)
internal val Res.string.badge_phoenix_desc: StringResource by lazy {
      StringResource("string:badge_phoenix_desc", "badge_phoenix_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1769, 70),
      ))
    }

@delegate:ResourceContentHash(672_919_470)
internal val Res.string.badge_polymath: StringResource by lazy {
      StringResource("string:badge_polymath", "badge_polymath", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1942, 34),
      ))
    }

@delegate:ResourceContentHash(-2_035_149_077)
internal val Res.string.badge_polymath_desc: StringResource by lazy {
      StringResource("string:badge_polymath_desc", "badge_polymath_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1874, 67),
      ))
    }

@delegate:ResourceContentHash(527_003_449)
internal val Res.string.badge_riddles_10: StringResource by lazy {
      StringResource("string:badge_riddles_10", "badge_riddles_10", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2043, 40),
      ))
    }

@delegate:ResourceContentHash(1_631_817_128)
internal val Res.string.badge_riddles_10_desc: StringResource by lazy {
      StringResource("string:badge_riddles_10_desc", "badge_riddles_10_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1977, 65),
      ))
    }

@delegate:ResourceContentHash(2_123_047_712)
internal val Res.string.badge_riddles_50: StringResource by lazy {
      StringResource("string:badge_riddles_50", "badge_riddles_50", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2150, 32),
      ))
    }

@delegate:ResourceContentHash(1_377_080_583)
internal val Res.string.badge_riddles_50_desc: StringResource by lazy {
      StringResource("string:badge_riddles_50_desc", "badge_riddles_50_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2084, 65),
      ))
    }

@delegate:ResourceContentHash(1_722_623_128)
internal val Res.string.badge_solved_10: StringResource by lazy {
      StringResource("string:badge_solved_10", "badge_solved_10", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2236, 39),
      ))
    }

@delegate:ResourceContentHash(-1_224_200_172)
internal val Res.string.badge_solved_10_desc: StringResource by lazy {
      StringResource("string:badge_solved_10_desc", "badge_solved_10_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2183, 52),
      ))
    }

@delegate:ResourceContentHash(-251_283_201)
internal val Res.string.badge_solved_150: StringResource by lazy {
      StringResource("string:badge_solved_150", "badge_solved_150", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2330, 40),
      ))
    }

@delegate:ResourceContentHash(-1_458_824_061)
internal val Res.string.badge_solved_150_desc: StringResource by lazy {
      StringResource("string:badge_solved_150_desc", "badge_solved_150_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2276, 53),
      ))
    }

@delegate:ResourceContentHash(-1_043_600_713)
internal val Res.string.badge_solved_25: StringResource by lazy {
      StringResource("string:badge_solved_25", "badge_solved_25", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2424, 31),
      ))
    }

@delegate:ResourceContentHash(355_930_646)
internal val Res.string.badge_solved_25_desc: StringResource by lazy {
      StringResource("string:badge_solved_25_desc", "badge_solved_25_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2371, 52),
      ))
    }

@delegate:ResourceContentHash(1_713_402_201)
internal val Res.string.badge_solved_300: StringResource by lazy {
      StringResource("string:badge_solved_300", "badge_solved_300", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2510, 36),
      ))
    }

@delegate:ResourceContentHash(1_514_807_741)
internal val Res.string.badge_solved_300_desc: StringResource by lazy {
      StringResource("string:badge_solved_300_desc", "badge_solved_300_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2456, 53),
      ))
    }

@delegate:ResourceContentHash(737_182_558)
internal val Res.string.badge_solved_5: StringResource by lazy {
      StringResource("string:badge_solved_5", "badge_solved_5", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2779, 38),
      ))
    }

@delegate:ResourceContentHash(-374_202_558)
internal val Res.string.badge_solved_50: StringResource by lazy {
      StringResource("string:badge_solved_50", "badge_solved_50", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2691, 39),
      ))
    }

@delegate:ResourceContentHash(-662_168_446)
internal val Res.string.badge_solved_500: StringResource by lazy {
      StringResource("string:badge_solved_500", "badge_solved_500", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2601, 36),
      ))
    }

@delegate:ResourceContentHash(-448_120_330)
internal val Res.string.badge_solved_500_desc: StringResource by lazy {
      StringResource("string:badge_solved_500_desc", "badge_solved_500_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2547, 53),
      ))
    }

@delegate:ResourceContentHash(-1_734_734_349)
internal val Res.string.badge_solved_50_desc: StringResource by lazy {
      StringResource("string:badge_solved_50_desc", "badge_solved_50_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2638, 52),
      ))
    }

@delegate:ResourceContentHash(1_945_382_415)
internal val Res.string.badge_solved_5_desc: StringResource by lazy {
      StringResource("string:badge_solved_5_desc", "badge_solved_5_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2731, 47),
      ))
    }

@delegate:ResourceContentHash(-784_933_258)
internal val Res.string.badge_streak_100: StringResource by lazy {
      StringResource("string:badge_streak_100", "badge_streak_100", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2880, 44),
      ))
    }

@delegate:ResourceContentHash(1_812_851_565)
internal val Res.string.badge_streak_100_desc: StringResource by lazy {
      StringResource("string:badge_streak_100_desc", "badge_streak_100_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2818, 61),
      ))
    }

@delegate:ResourceContentHash(573_895_997)
internal val Res.string.badge_streak_14: StringResource by lazy {
      StringResource("string:badge_streak_14", "badge_streak_14", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2982, 43),
      ))
    }

@delegate:ResourceContentHash(-89_166_434)
internal val Res.string.badge_streak_14_desc: StringResource by lazy {
      StringResource("string:badge_streak_14_desc", "badge_streak_14_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2925, 56),
      ))
    }

@delegate:ResourceContentHash(1_772_631_602)
internal val Res.string.badge_streak_3: StringResource by lazy {
      StringResource("string:badge_streak_3", "badge_streak_3", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3286, 34),
      ))
    }

@delegate:ResourceContentHash(-1_337_934_725)
internal val Res.string.badge_streak_30: StringResource by lazy {
      StringResource("string:badge_streak_30", "badge_streak_30", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3083, 39),
      ))
    }

@delegate:ResourceContentHash(-1_166_980_159)
internal val Res.string.badge_streak_30_desc: StringResource by lazy {
      StringResource("string:badge_streak_30_desc", "badge_streak_30_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3026, 56),
      ))
    }

@delegate:ResourceContentHash(-360_153_132)
internal val Res.string.badge_streak_365: StringResource by lazy {
      StringResource("string:badge_streak_365", "badge_streak_365", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3185, 44),
      ))
    }

@delegate:ResourceContentHash(1_334_958_560)
internal val Res.string.badge_streak_365_desc: StringResource by lazy {
      StringResource("string:badge_streak_365_desc", "badge_streak_365_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3123, 61),
      ))
    }

@delegate:ResourceContentHash(899_983_947)
internal val Res.string.badge_streak_3_desc: StringResource by lazy {
      StringResource("string:badge_streak_3_desc", "badge_streak_3_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3230, 55),
      ))
    }

@delegate:ResourceContentHash(580_927_904)
internal val Res.string.badge_streak_60: StringResource by lazy {
      StringResource("string:badge_streak_60", "badge_streak_60", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3378, 39),
      ))
    }

@delegate:ResourceContentHash(178_969_465)
internal val Res.string.badge_streak_60_desc: StringResource by lazy {
      StringResource("string:badge_streak_60_desc", "badge_streak_60_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3321, 56),
      ))
    }

@delegate:ResourceContentHash(-502_574_140)
internal val Res.string.badge_streak_7: StringResource by lazy {
      StringResource("string:badge_streak_7", "badge_streak_7", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3474, 38),
      ))
    }

@delegate:ResourceContentHash(-695_724_028)
internal val Res.string.badge_streak_7_desc: StringResource by lazy {
      StringResource("string:badge_streak_7_desc", "badge_streak_7_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3418, 55),
      ))
    }

@delegate:ResourceContentHash(661_537_667)
internal val Res.string.badge_triple_threat: StringResource by lazy {
      StringResource("string:badge_triple_threat", "badge_triple_threat", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3590, 47),
      ))
    }

@delegate:ResourceContentHash(1_426_483_748)
internal val Res.string.badge_triple_threat_desc: StringResource by lazy {
      StringResource("string:badge_triple_threat_desc", "badge_triple_threat_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3513, 76),
      ))
    }

@delegate:ResourceContentHash(1_231_868_928)
internal val Res.string.badge_words_10: StringResource by lazy {
      StringResource("string:badge_words_10", "badge_words_10", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3706, 38),
      ))
    }

@delegate:ResourceContentHash(-965_389_403)
internal val Res.string.badge_words_10_desc: StringResource by lazy {
      StringResource("string:badge_words_10_desc", "badge_words_10_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3638, 67),
      ))
    }

@delegate:ResourceContentHash(-492_735_628)
internal val Res.string.badge_words_50: StringResource by lazy {
      StringResource("string:badge_words_50", "badge_words_50", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3813, 34),
      ))
    }

@delegate:ResourceContentHash(1_319_474_052)
internal val Res.string.badge_words_50_desc: StringResource by lazy {
      StringResource("string:badge_words_50_desc", "badge_words_50_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3745, 67),
      ))
    }

@delegate:ResourceContentHash(1_535_307_061)
internal val Res.string.badges_count: StringResource by lazy {
      StringResource("string:badges_count", "badges_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3848, 36),
      ))
    }

@delegate:ResourceContentHash(2_608_025)
internal val Res.string.badges_new: StringResource by lazy {
      StringResource("string:badges_new", "badges_new", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3885, 22),
      ))
    }

@delegate:ResourceContentHash(154_612_765)
internal val Res.string.badges_see_all: StringResource by lazy {
      StringResource("string:badges_see_all", "badges_see_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3908, 34),
      ))
    }

@delegate:ResourceContentHash(912_074_905)
internal val Res.string.badges_subtitle: StringResource by lazy {
      StringResource("string:badges_subtitle", "badges_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3943, 67),
      ))
    }

@delegate:ResourceContentHash(-507_040_867)
internal val Res.string.badges_title: StringResource by lazy {
      StringResource("string:badges_title", "badges_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4011, 28),
      ))
    }

@delegate:ResourceContentHash(-1_312_061_142)
internal val Res.string.badges_unlocked_on: StringResource by lazy {
      StringResource("string:badges_unlocked_on", "badges_unlocked_on", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4040, 46),
      ))
    }

@delegate:ResourceContentHash(-1_438_907_004)
internal val Res.string.brainstorm_continue: StringResource by lazy {
      StringResource("string:brainstorm_continue", "brainstorm_continue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4087, 39),
      ))
    }

@delegate:ResourceContentHash(-1_651_756_282)
internal val Res.string.brainstorm_end: StringResource by lazy {
      StringResource("string:brainstorm_end", "brainstorm_end", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4127, 34),
      ))
    }

@delegate:ResourceContentHash(-49_877_534)
internal val Res.string.brainstorm_kicker: StringResource by lazy {
      StringResource("string:brainstorm_kicker", "brainstorm_kicker", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4162, 57),
      ))
    }

@delegate:ResourceContentHash(570_548_907)
internal val Res.string.brainstorm_next_round: StringResource by lazy {
      StringResource("string:brainstorm_next_round", "brainstorm_next_round", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4220, 53),
      ))
    }

@delegate:ResourceContentHash(-2_112_361_982)
internal val Res.string.brainstorm_nice: StringResource by lazy {
      StringResource("string:brainstorm_nice", "brainstorm_nice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4274, 35),
      ))
    }

@delegate:ResourceContentHash(-1_190_336_845)
internal val Res.string.brainstorm_round_done: StringResource by lazy {
      StringResource("string:brainstorm_round_done", "brainstorm_round_done", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4421, 49),
      ))
    }

@delegate:ResourceContentHash(1_130_813_046)
internal val Res.string.brainstorm_round_done_body: StringResource by lazy {
      StringResource("string:brainstorm_round_done_body", "brainstorm_round_done_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4310, 110),
      ))
    }

@delegate:ResourceContentHash(1_384_105_710)
internal val Res.string.brainstorm_up_next: StringResource by lazy {
      StringResource("string:brainstorm_up_next", "brainstorm_up_next", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4471, 38),
      ))
    }

@delegate:ResourceContentHash(-723_006_221)
internal val Res.string.challenge_accept: StringResource by lazy {
      StringResource("string:challenge_accept", "challenge_accept", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4510, 48),
      ))
    }

@delegate:ResourceContentHash(-1_285_172_257)
internal val Res.string.challenge_continue: StringResource by lazy {
      StringResource("string:challenge_continue", "challenge_continue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4640, 70),
      ))
    }

@delegate:ResourceContentHash(-2_617_532)
internal val Res.string.challenge_continue_title: StringResource by lazy {
      StringResource("string:challenge_continue_title", "challenge_continue_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4559, 80),
      ))
    }

@delegate:ResourceContentHash(106_752_972)
internal val Res.string.challenge_dont_ask: StringResource by lazy {
      StringResource("string:challenge_dont_ask", "challenge_dont_ask", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4711, 50),
      ))
    }

@delegate:ResourceContentHash(-1_505_125_104)
internal val Res.string.challenge_invite_body: StringResource by lazy {
      StringResource("string:challenge_invite_body", "challenge_invite_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4762, 73),
      ))
    }

@delegate:ResourceContentHash(1_006_569_647)
internal val Res.string.challenge_later: StringResource by lazy {
      StringResource("string:challenge_later", "challenge_later", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4836, 31),
      ))
    }

@delegate:ResourceContentHash(-440_902_030)
internal val Res.string.challenge_missing_puzzle: StringResource by lazy {
      StringResource("string:challenge_missing_puzzle", "challenge_missing_puzzle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4868, 112),
      ))
    }

@delegate:ResourceContentHash(-1_518_684_032)
internal val Res.string.challenge_offer_score: StringResource by lazy {
      StringResource("string:challenge_offer_score", "challenge_offer_score", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4981, 89),
      ))
    }

@delegate:ResourceContentHash(-1_940_385_937)
internal val Res.string.challenge_offer_time: StringResource by lazy {
      StringResource("string:challenge_offer_time", "challenge_offer_time", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5071, 60),
      ))
    }

@delegate:ResourceContentHash(337_859_280)
internal val Res.string.challenge_offer_title: StringResource by lazy {
      StringResource("string:challenge_offer_title", "challenge_offer_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5132, 97),
      ))
    }

@delegate:ResourceContentHash(564_395_000)
internal val Res.string.challenge_own_app_share: StringResource by lazy {
      StringResource("string:challenge_own_app_share", "challenge_own_app_share", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5230, 91),
      ))
    }

@delegate:ResourceContentHash(288_934_841)
internal val Res.string.challenge_own_link: StringResource by lazy {
      StringResource("string:challenge_own_link", "challenge_own_link", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5322, 90),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("achievement_awesome", Res.string.achievement_awesome)
  map.put("achievement_share", Res.string.achievement_share)
  map.put("achievement_unlocked_kicker", Res.string.achievement_unlocked_kicker)
  map.put("app_name", Res.string.app_name)
  map.put("badge_brainstorm_25", Res.string.badge_brainstorm_25)
  map.put("badge_brainstorm_25_desc", Res.string.badge_brainstorm_25_desc)
  map.put("badge_brainstorm_5", Res.string.badge_brainstorm_5)
  map.put("badge_brainstorm_5_desc", Res.string.badge_brainstorm_5_desc)
  map.put("badge_brainstormer", Res.string.badge_brainstormer)
  map.put("badge_brainstormer_desc", Res.string.badge_brainstormer_desc)
  map.put("badge_first_daily", Res.string.badge_first_daily)
  map.put("badge_first_daily_desc", Res.string.badge_first_daily_desc)
  map.put("badge_first_numbers", Res.string.badge_first_numbers)
  map.put("badge_first_numbers_desc", Res.string.badge_first_numbers_desc)
  map.put("badge_first_riddles", Res.string.badge_first_riddles)
  map.put("badge_first_riddles_desc", Res.string.badge_first_riddles_desc)
  map.put("badge_first_words", Res.string.badge_first_words)
  map.put("badge_first_words_desc", Res.string.badge_first_words_desc)
  map.put("badge_flawless", Res.string.badge_flawless)
  map.put("badge_flawless_desc", Res.string.badge_flawless_desc)
  map.put("badge_numbers_10", Res.string.badge_numbers_10)
  map.put("badge_numbers_10_desc", Res.string.badge_numbers_10_desc)
  map.put("badge_numbers_50", Res.string.badge_numbers_50)
  map.put("badge_numbers_50_desc", Res.string.badge_numbers_50_desc)
  map.put("badge_perfect_100", Res.string.badge_perfect_100)
  map.put("badge_perfect_100_desc", Res.string.badge_perfect_100_desc)
  map.put("badge_perfect_5", Res.string.badge_perfect_5)
  map.put("badge_perfect_5_desc", Res.string.badge_perfect_5_desc)
  map.put("badge_perfectionist", Res.string.badge_perfectionist)
  map.put("badge_perfectionist_desc", Res.string.badge_perfectionist_desc)
  map.put("badge_phoenix", Res.string.badge_phoenix)
  map.put("badge_phoenix_3", Res.string.badge_phoenix_3)
  map.put("badge_phoenix_3_desc", Res.string.badge_phoenix_3_desc)
  map.put("badge_phoenix_desc", Res.string.badge_phoenix_desc)
  map.put("badge_polymath", Res.string.badge_polymath)
  map.put("badge_polymath_desc", Res.string.badge_polymath_desc)
  map.put("badge_riddles_10", Res.string.badge_riddles_10)
  map.put("badge_riddles_10_desc", Res.string.badge_riddles_10_desc)
  map.put("badge_riddles_50", Res.string.badge_riddles_50)
  map.put("badge_riddles_50_desc", Res.string.badge_riddles_50_desc)
  map.put("badge_solved_10", Res.string.badge_solved_10)
  map.put("badge_solved_10_desc", Res.string.badge_solved_10_desc)
  map.put("badge_solved_150", Res.string.badge_solved_150)
  map.put("badge_solved_150_desc", Res.string.badge_solved_150_desc)
  map.put("badge_solved_25", Res.string.badge_solved_25)
  map.put("badge_solved_25_desc", Res.string.badge_solved_25_desc)
  map.put("badge_solved_300", Res.string.badge_solved_300)
  map.put("badge_solved_300_desc", Res.string.badge_solved_300_desc)
  map.put("badge_solved_5", Res.string.badge_solved_5)
  map.put("badge_solved_50", Res.string.badge_solved_50)
  map.put("badge_solved_500", Res.string.badge_solved_500)
  map.put("badge_solved_500_desc", Res.string.badge_solved_500_desc)
  map.put("badge_solved_50_desc", Res.string.badge_solved_50_desc)
  map.put("badge_solved_5_desc", Res.string.badge_solved_5_desc)
  map.put("badge_streak_100", Res.string.badge_streak_100)
  map.put("badge_streak_100_desc", Res.string.badge_streak_100_desc)
  map.put("badge_streak_14", Res.string.badge_streak_14)
  map.put("badge_streak_14_desc", Res.string.badge_streak_14_desc)
  map.put("badge_streak_3", Res.string.badge_streak_3)
  map.put("badge_streak_30", Res.string.badge_streak_30)
  map.put("badge_streak_30_desc", Res.string.badge_streak_30_desc)
  map.put("badge_streak_365", Res.string.badge_streak_365)
  map.put("badge_streak_365_desc", Res.string.badge_streak_365_desc)
  map.put("badge_streak_3_desc", Res.string.badge_streak_3_desc)
  map.put("badge_streak_60", Res.string.badge_streak_60)
  map.put("badge_streak_60_desc", Res.string.badge_streak_60_desc)
  map.put("badge_streak_7", Res.string.badge_streak_7)
  map.put("badge_streak_7_desc", Res.string.badge_streak_7_desc)
  map.put("badge_triple_threat", Res.string.badge_triple_threat)
  map.put("badge_triple_threat_desc", Res.string.badge_triple_threat_desc)
  map.put("badge_words_10", Res.string.badge_words_10)
  map.put("badge_words_10_desc", Res.string.badge_words_10_desc)
  map.put("badge_words_50", Res.string.badge_words_50)
  map.put("badge_words_50_desc", Res.string.badge_words_50_desc)
  map.put("badges_count", Res.string.badges_count)
  map.put("badges_new", Res.string.badges_new)
  map.put("badges_see_all", Res.string.badges_see_all)
  map.put("badges_subtitle", Res.string.badges_subtitle)
  map.put("badges_title", Res.string.badges_title)
  map.put("badges_unlocked_on", Res.string.badges_unlocked_on)
  map.put("brainstorm_continue", Res.string.brainstorm_continue)
  map.put("brainstorm_end", Res.string.brainstorm_end)
  map.put("brainstorm_kicker", Res.string.brainstorm_kicker)
  map.put("brainstorm_next_round", Res.string.brainstorm_next_round)
  map.put("brainstorm_nice", Res.string.brainstorm_nice)
  map.put("brainstorm_round_done", Res.string.brainstorm_round_done)
  map.put("brainstorm_round_done_body", Res.string.brainstorm_round_done_body)
  map.put("brainstorm_up_next", Res.string.brainstorm_up_next)
  map.put("challenge_accept", Res.string.challenge_accept)
  map.put("challenge_continue", Res.string.challenge_continue)
  map.put("challenge_continue_title", Res.string.challenge_continue_title)
  map.put("challenge_dont_ask", Res.string.challenge_dont_ask)
  map.put("challenge_invite_body", Res.string.challenge_invite_body)
  map.put("challenge_later", Res.string.challenge_later)
  map.put("challenge_missing_puzzle", Res.string.challenge_missing_puzzle)
  map.put("challenge_offer_score", Res.string.challenge_offer_score)
  map.put("challenge_offer_time", Res.string.challenge_offer_time)
  map.put("challenge_offer_title", Res.string.challenge_offer_title)
  map.put("challenge_own_app_share", Res.string.challenge_own_app_share)
  map.put("challenge_own_link", Res.string.challenge_own_link)
}
